import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const CentersInfoRedux = createActions(
  {
    getCentersInfoRequest: ['centerId', 'path'],
    getCentersAttendanceSuccess: ['data'],
    getCentersOverviewSuccess: ['data'],
    getCentersStudentsCheckinSuccess: ['data'],
    getCentersVisitAverageSuccess: ['data'],
    getCentersDailyAttendanceSuccess: ['data'],
    getCentersDemographicsSuccess: ['data'],
    getCentersDisenrollmentsSuccess: ['data'],
    getCentersCheckinsSuccess: ['data'],
    getCentersActiveCheckinsSuccess: ['data'],
    getCentersTeacherDistributionSuccess: ['data'],
    getCentersFinancesSuccess: ['data'],
    getCentersRatingsSuccess: ['data'],
    getCentersNetSuccess: ['data'],
    getCentersMotivesSuccess: ['data'],
    getCentersInfoError: ['err'],
    setCenter: ['id'],
    setCenterName: ['name'],
  },
  {
    prefix: 'CENTERS_INFO_',
    defaultActions: {},
  },
)

const { Types, Creators } = CentersInfoRedux
export const CentersInfoTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  centers_info: {
    fetching: false,
    results: [],
    errors: null,
  },
  attendance: {
    fetching: false,
    results: [],
    errors: null,
  },
  overview: {
    fetching: false,
    results: [],
    errors: null,
  },
  students_checkin: {
    fetching: false,
    results: [],
    errors: null,
  },
  center_visit_average: {
    fetching: false,
    results: [],
    errors: null,
  },
  daily: {
    fetching: false,
    results: [],
    errors: null,
  },
  checkins: {
    fetching: false,
    results: [],
    errors: null,
  },
  active_checkins: {
    fetching: false,
    results: [],
    errors: null,
  },
  teacher_distribution: {
    fetching: false,
    results: [],
    errors: null,
  },
  demographics: {
    fetching: false,
    results: [],
    errors: null,
  },
  disenrollments: {
    fetching: false,
    results: [],
    errors: null,
  },
  net: {
    fetching: false,
    results: [],
    errors: null,
  },
  motives: {
    fetching: false,
    results: [],
    errors: null,
  },
  finances: {
    fetching: false,
    results: [],
    errors: null,
  },
  ratings: {
    fetching: false,
    results: [],
    errors: null,
  },
  center: 0,
  name: null,
},
{
  fetching: false,
  results: [],
  errors: null,
})

const getCentersInfoRequest = state => state.merge({ fetching: true }, d)

const getCentersOverviewSuccess = (state, data) =>
  state.merge({ overview: { fetching: false, results: data.data, errors: null } }, d)

const getCentersAttendanceSuccess = (state, data) =>
  state.merge({ attendance: { fetching: false, results: data.data, errors: null } }, d)

const getCentersStudentsCheckinSuccess = (state, data) =>
  state.merge({ students_checkin: { fetching: false, results: data.data, errors: null } }, d)

const getCentersVisitAverageSuccess = (state, data) =>
  state.merge({ center_visit_average: { fetching: false, results: data.data, errors: null } }, d)

const getCentersDailyAttendanceSuccess = (state, data) =>
  state.merge({ daily: { fetching: false, results: data.data, errors: null } }, d)

const getCentersCheckinsSuccess = (state, data) =>
  state.merge({ checkins: { fetching: false, results: data.data, errors: null } }, d)

const getCentersActiveCheckinsSuccess = (state, data) =>
  state.merge({ active_checkins: { fetching: false, results: data.data, errors: null } }, d)

const getCentersTeacherDistributionSuccess = (state, data) =>
  state.merge({ teacher_distribution: { fetching: false, results: data.data, errors: null } }, d)

const getCentersDemographicsSuccess = (state, data) =>
  state.merge({ demographics: { fetching: false, results: data.data, errors: null } }, d)

const getCentersDisenrollmentsSuccess = (state, data) =>
  state.merge({ disenrollments: { fetching: false, results: data.data, errors: null } }, d)

const getCentersNetSuccess = (state, data) =>
  state.merge({ net: { fetching: false, results: data.data, errors: null } }, d)

const getCentersFinancesSuccess = (state, data) =>
  state.merge({ finances: { fetching: false, results: data.data, errors: null } }, d)

const getCentersMotivesSuccess = (state, data) =>
  state.merge({ motives: { fetching: false, results: data.data, errors: null } }, d)

const getCentersRatingsSuccess = (state, data) =>
  state.merge({ ratings: { fetching: false, results: data.data, errors: null } }, d)

const getCentersInfoError = (state, { err }) =>
  state.merge({ fetching: false, results: [], errors: err }, d)

const setCenter = (state, { id }) => state.merge({ center: id }, d)
const setCenterName = (state, { name }) => state.merge({ name }, d)

export const reducer = createReducer(INITIAL_STATE, {
  [Types.getCentersInfoRequest]: getCentersInfoRequest,
  [Types.getCentersAttendanceSuccess]: getCentersAttendanceSuccess,
  [Types.getCentersOverviewSuccess]: getCentersOverviewSuccess,
  [Types.getCentersStudentsCheckinSuccess]: getCentersStudentsCheckinSuccess,
  [Types.getCentersVisitAverageSuccess]: getCentersVisitAverageSuccess,
  [Types.getCentersDailyAttendanceSuccess]: getCentersDailyAttendanceSuccess,
  [Types.getCentersActiveCheckinsSuccess]: getCentersActiveCheckinsSuccess,
  [Types.getCentersCheckinsSuccess]: getCentersCheckinsSuccess,
  [Types.getCentersTeacherDistributionSuccess]: getCentersTeacherDistributionSuccess,
  [Types.getCentersDemographicsSuccess]: getCentersDemographicsSuccess,
  [Types.getCentersDisenrollmentsSuccess]: getCentersDisenrollmentsSuccess,
  [Types.getCentersFinancesSuccess]: getCentersFinancesSuccess,
  [Types.getCentersMotivesSuccess]: getCentersMotivesSuccess,
  [Types.getCentersRatingsSuccess]: getCentersRatingsSuccess,
  [Types.getCentersInfoError]: getCentersInfoError,
  [Types.getCentersNetSuccess]: getCentersNetSuccess,
  [Types.setCenter]: setCenter,
  [Types.setCenterName]: setCenterName,
},
{
  defaultActions: {},
  Types,
})



// WEBPACK FOOTER //
// ./src/Data/Redux/CentersInfoRedux.js